import { Icon, Typography } from '@vp/swan'
import { useSocialMediaGallery } from '~/app/features/Gallery/hooks/useSocialMediaGallery'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'
import { useSelector } from 'react-redux'
import { getQuantitySelector, getMpvid } from '~/app/store/config'
import { PriceDisplay } from '@vp/price-platform'
import { userOptionsSelector } from '~/app/store/refinement/selectors'
import { buildPriceDisplaySelections } from '~/app/utils/buildPriceDisplaySelections'
import { useFeatureGate } from '~/app/features/Gallery/hooks/useFeatureGate'
import { FEATURE_GATES } from '~/shared/featureGates/constants'

export const UploadTile = () => {
  const localize = useTranslations()
  const mpvId = useSelector(getMpvid)
  const quantity = useSelector(getQuantitySelector)
  const shouldHideForSocialMedia = useSocialMediaGallery()
  const userOptions = useSelector(userOptionsSelector)
  const isHeroPriceEnabled = useFeatureGate(FEATURE_GATES.GALLERY_PRICE_IN_HEADER)

  return (
    <div className="clickable tile-action-area fbu-action-area" data-testid="fbu-tile" role="presentation">
      <div className="fbu-content">
        <div className="fbu-upload-icon-circle">
          <Icon className="fbu-upload-icon" iconType="upload" />
        </div>

        <Typography className="fbu-header-text" fontWeight="bold">
          {localize('FullBleedUploadTileHeader')}
        </Typography>

        {!shouldHideForSocialMedia && !isHeroPriceEnabled && (
          <PriceDisplay mpvId={mpvId} selections={buildPriceDisplaySelections(userOptions as Record<string, string>, quantity)} isTile />
        )}
      </div>
    </div>
  )
}
